export default {
  onboarding: {
    stepWelcome: "Welcome",
    stepProducts: "Your products",
    stepCompetitors: "Competitors",
    stepSummary: "Summary",
    catalogLoadError: "Couldn't load the catalogue. Please try again.",
    saveError: "Error saving the configuration",
    welcomeTitle: "Welcome to HelixScan",
    welcomeBody1: "We'll set up your organization in 3 minutes: you'll pick your ",
    welcomeStrong1: "laboratory's products",
    welcomeBody2: " from the official CIMA (AEMPS) catalogue and the ",
    welcomeStrong2: "competitor products",
    welcomeBody3: " you want to monitor.",
    welcomeNote: "From that moment on, every price, funding or safety change affecting your products or your competitors will be flagged and prioritized automatically.",
    readonlyNotice: "Your account is read-only: ask an administrator of your organization to complete the setup.",
    startSetup: "Start setup",
    later: "I'll do it later",
    labStepTitle: "1 · Find your laboratory",
    labStepDesc: "Official CIMA – AEMPS catalogue (25,000+ medicines). You can add products from several laboratories.",
    labSearchPlaceholder: "E.g.: Italfarmaco, Kern Pharma, Cinfa…",
    searching: "Searching…",
    productFilterPlaceholder: "Filter products…",
    selectMarketed: "+ Select marketed",
    loadingCatalog: "Loading catalogue…",
    alreadyInPortfolio: "already in your portfolio",
    notMarketed: "not marketed",
    noFilterResults: "No results for this filter",
    back: "Back",
    productsSelectedOne: "{n} product selected",
    productsSelectedMany: "{n} products selected",
    continue: "Continue",
    competitorsStepTitle: "2 · Choose your competitors",
    competitorsBody1: "We suggest marketed medicines with the ",
    competitorsStrong: "same active substance",
    competitorsBody2: " as your products, from other laboratories. Select the ones you want to monitor.",
    searchingCompetitors: "Searching for competitors in the catalogue…",
    noCompetitors: "No direct competitors were found in the catalogue. You can add them manually under «Competitors».",
    removeAll: "Remove all",
    selectAll: "Select all",
    compsSelectedOne: "{n} competitor",
    compsSelectedMany: "{n} competitors",
    summaryStepTitle: "3 · Summary",
    portfolioProducts: "Products in your portfolio",
    competitorsToMonitor: "Competitors to monitor",
    summaryNote: "You can add or remove products and competitors at any time from the «Settings» menu.",
    saving: "Saving…",
    finishSetup: "Finish setup",
  },
};
